import { createSlice } from '@reduxjs/toolkit';
import LoadingStatus from 'enums/loadingStatus';
import { dataInitialState } from './initialState';

export const DATA_SLICE_KEY = 'mapData';

const mapDataSlice = createSlice({
  name: DATA_SLICE_KEY,
  initialState: dataInitialState,
  reducers: {
    updateCoordinates: (state, action) => {
      state.geoCoordinates = action.payload;
    },
    fetchResults: (state) => {
      state.fetchResultsStatus = LoadingStatus.Loading.toString();
      state.fetchResultsError = null;
    },
    fetchResultsError: (state, action) => {
      state.fetchResultsStatus = LoadingStatus.Failed.toString();
      state.fetchResultsError = action.payload;
    },
    fetchResultsFulfilled: (state, action) => {
      state.results = action.payload;
      state.fetchResultsStatus = LoadingStatus.Succeeded.toString();
    },
    fetchSitePlans: (state) => {
      state.fetchSitePlansStatus = LoadingStatus.Loading.toString();
    },
    fetchSitePlansError: (state, action) => {
      state.fetchSitePlansStatus = LoadingStatus.Failed.toString();
      state.fetchSitePlansError = action.payload;
    },
    fetchSitePlansFulfilled: (state, action) => {
      state.sitePlans = action.payload;
      state.fetchSitePlansStatus = LoadingStatus.Succeeded.toString();
    },
    fetchBuildablePlans: () => {},
    // Card data is pushed to interactionSlice.carouselCards by the epic; this action only resets the loading status."
    fetchBuildablePlansFulfilled: (state) => {
      state.fetchBuildablePlansStatus = LoadingStatus.Succeeded.toString();
    },
    fetchBuildablePlansError: (state, action) => {
      state.fetchBuildablePlansStatus = LoadingStatus.Failed.toString();
      state.fetchBuildablePlansError = action.payload;
    },
    clearSitePlans: (state) => {
      state.sitePlans = [];
      state.fetchSitePlansStatus = LoadingStatus.Idle.toString();
      state.fetchSitePlansError = null;
    },
  },
});

export default mapDataSlice;
